import __request__ from "routing/request";
export function getByIds(body, requestOptions) {
  return __request__("POST", "/events/byIds", body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function filterOptions(JSONbody, requestOptions) {
  return __request__("POST", "/events/filter_options", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function histogram(JSONbody, requestOptions) {
  return __request__("POST", "/events/histogram", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function search(JSONbody, requestOptions) {
  return __request__("POST", "/events/search", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function slices(JSONbody, requestOptions) {
  return __request__("POST", "/events/slices", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(event_id, requestOptions) {
  return __request__("GET", `/events/${event_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
